// extracted by mini-css-extract-plugin
export default {"animateIn":"AnimateIn_animateIn__4GPT9","fadeInUp":"AnimateIn_fadeInUp__bP96R"};